import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion"; // Import Framer Motion
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import Navbar from "./components/navbar"; // Import your Navbar component
import Footer from "./components/footer"; // Import your Footer component


const NotFound = () => {
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    navigate("/"); // Redirect to the homepage or dashboard
  };

  // Animation variants for Framer Motion
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.5 } },
  };

  const buttonVariants = {
    hover: { scale: 1.05, backgroundColor: "#005D33" },
    tap: { scale: 0.95 },
  };

  // Lottie animation URL (example from LottieFiles)
  const animationUrl =
    "https://assets10.lottiefiles.com/packages/lf20_ghfpce1h.json";

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar /> {/* Include the Navbar */}
      <motion.div
        className="flex-grow flex flex-col items-center justify-center p-8 h-screen"
        style={{ backgroundColor: "white" }}
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {/* Lottie Animation from URL */}
        <div className="w-full max-w-md mb-8">
        <DotLottieReact
      src="https://lottie.host/a03304ca-950c-49f2-8c5a-37eb758390c8/y6GrquXU7k.lottie"
      loop
      autoplay
    />
        </div>

        <p className="text-2xl text-[#007D44] mb-8">Oops! Page Not Found</p>
        <motion.button
          onClick={handleGoToDashboard}
          className="px-6 py-3 bg-[#007D44] text-white rounded-lg"
          variants={buttonVariants}
          whileHover="hover"
          whileTap="tap"
        >
          Go to Dashboard
        </motion.button>
      </motion.div>
      <Footer /> {/* Include the Footer */}
    </div>
  );
};

export default NotFound;

